import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, watch, getCurrentInstance, withDefaults } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { isUniFrameWork } from '../../../utils/env';

interface IProps {
  isFetching: boolean;
  isTerminateObserve?: boolean;
}

interface IEmits {
  (e: 'onExposed'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isFetching: { type: Boolean, default: false },
    isTerminateObserve: { type: Boolean, default: false }
  },
  emits: ["onExposed"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onExposed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isFetching: boolean, isTerminateObserve: boolean }




let observer: unknown = null;
const selfDomRef = ref();
const thisInstance = getCurrentInstance()?.proxy || getCurrentInstance();

onMounted(() => {
  if (props.isTerminateObserve) {
    return;
  }
  if (!isUniFrameWork) {
    observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        emits('onExposed');
      }
    }, {
      threshold: 1.0,
    });
    if (selfDomRef.value) {
      (observer as IntersectionObserver).observe(selfDomRef.value);
    }
  } else {
    observer = uni.createIntersectionObserver(thisInstance).relativeToViewport();
    (observer as any).observe('.fetch-more-block', () => {
      emits('onExposed');
    });
  }
});

onUnmounted(() => {
  if (observer) {
    (observer as IntersectionObserver).disconnect();
    observer = null;
  }
});

watch(() => props.isTerminateObserve, (isTerminateObserve: boolean) => {
  if (!observer) {
    return;
  }
  if (isTerminateObserve) {
    (observer as IntersectionObserver).disconnect();
  } else if (selfDomRef.value) {
    (observer as IntersectionObserver).disconnect();
    if (!isUniFrameWork) {
      (observer as IntersectionObserver).observe(selfDomRef.value);
    } else {
      (observer as any).observe('.fetch-more-block', () => {
        emits('onExposed');
      });
    }
  }
});

return { __sfc: true,emits, props, observer, selfDomRef, thisInstance, TUITranslateService }
}

})